import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { ShapeSettings } from '../setting/ShapeSettings';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;

const Blockly = GlobalImport.getBlockly();

const DECISION = 'DECISION';
const TRUE_PART = 'TRUE_PART';
const FALSE_PART = 'FALSE_PART';
export class IfElseBlock extends AbstractBlock {
  constructor() {
    super('logic_ifelse_v2', t.to('もしならでなければ', 'if_else'));
  }
  defineBlock(block: BlockType): void {
    ColorSettings.setLogicColor(block);
    ShapeSettings.setElementShape(block);

    block.appendValueInput(DECISION).setCheck('Boolean').appendField(t.to('もし', 'if_label'));
    block.appendDummyInput().appendField(t.to('なら', 'then_label'));
    block.appendStatementInput(TRUE_PART);
    block.appendDummyInput().appendField(t.to('でなければ', 'else_label'));
    block.appendStatementInput(FALSE_PART);
  }

  codeGenerateCore(block: BlockType): string {
    const decision = CodeSetting.getInputValue(block, DECISION);
    const true_part = Blockly.JavaScript.statementToCode(
      block,
      TRUE_PART,
      Blockly.JavaScript.ORDER_NONE
    );
    const false_part = Blockly.JavaScript.statementToCode(
      block,
      FALSE_PART,
      Blockly.JavaScript.ORDER_NONE
    );

    const str = `if( ${decision} ){
			${true_part}
		} else {
			${false_part}
		}`;
    return str;
  }
}
